import React from 'react';
import './OurProjects.css';
import project1Image from '../Assets/proj1.png'; // Replace with your actual image path
import project2Image from '../Assets/proj2.jpg'; // Replace with your actual image path

const OurProjects = () => {
  const projectsData = [
    {
      id: 1,
      title: 'FOR JSW - BSPL - SAMBALPUR',
      image: project1Image,
      details: [
        'Acquisition of 250 acres of private & alienation of 200 acres Govt land in Sambalpur and Jharsuguda Districts for 5 MTPA Plant Expansion',
        'Rehabilitation & Resettlement of 300 PDFs',
        'Compensatory afforestation land of 300 acres with fly ash dumping, slag dumping and land regularisation for other projects',
        'Conduct SIA PH, Gram Sabha & other PHs',
        'Regularisation of around 150 acres of land and land dispute regulations'
      ]
    },
    {
      id: 2,
      title: 'BGR (MDO - VEDANTA LIMITED) FOR JAMKHANI COAL BLOCK - SUNDERGARH',
      image: project2Image,
      details: [
        'Facilitation of Ex-gratia negotiation, conduct of PH/ Gram Sabha & consent of land owners for starting mining operation in Sundergarh',
        'Other mining projects in pipeline in Sundargarh, District',
        'Greenfield Railway Siding Projects for various entities in Sundergarh District on end to end basis - 3 nos'
      ]
    }
  ];

  return (
    <section className="project-cbge-section">
      <div className="project-cbge-container">
        {/* Header */}
        <div className="project-cbge-header">
          <span className="project-cbge-badge">Our Projects</span>
          <h1 className="project-cbge-title" data-aos="fade-up">
            Transforming Vision into <br />
            Impactful Infrastructure
          </h1>
          <p className="project-cbge-subtitle" data-aos="fade-up">
            Delivering comprehensive solutions for large-scale projects across land acquisition, community engagement, and infrastructure development.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="project-cbge-grid">
          {projectsData.map((project) => (
            <div key={project.id} className="project-cbge-card" data-aos="fade-up">
              <div className="project-cbge-image-wrapper">
                <img 
                  src={project.image} 
                  alt={project.title} 
                  className="project-cbge-image"
                />
              </div>
              <div className="project-cbge-content">
                <h3 className="project-cbge-card-title">{project.title}</h3>
                <ul className="project-cbge-details-list">
                  {project.details.map((detail, index) => (
                    <li key={index} className="project-cbge-detail-item">
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurProjects;